import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
/** Get ad mediums */ export const getAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adMediumFilterParams === undefined) {
        throw new Error('Missing required body: adMediumFilterParams');
    }
    const path = '/api/ws-broadcast/ad-mediums/filter';
    const pathInternal = '/api/ad-mediums/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumFilterParams !== undefined) {
        body = params.adMediumFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdMediums.paramsOrder = [{ type: 'body', paramName: 'adMediumFilterParams' }];
/** Create new ad medium */ export const createAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adMediumForm === undefined) {
        throw new Error('Missing required body: adMediumForm');
    }
    const path = '/api/ws-broadcast/ad-mediums';
    const pathInternal = '/api/ad-mediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumForm !== undefined) {
        body = params.adMediumForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMediumForm' }];
/** Get ad medium by id */ export const getAdMediumById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-broadcast/ad-mediums/{adMediumId}'.replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)));
    const pathInternal = '/api/ad-mediums/{adMediumId}'.replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdMediumById.paramsOrder = [{ type: 'parameters' }];
/** Update ad medium */ export const updateAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    if (params.adMediumForm === undefined) {
        throw new Error('Missing required body: adMediumForm');
    }
    const path = '/api/ws-broadcast/ad-mediums/{adMediumId}'.replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)));
    const pathInternal = '/api/ad-mediums/{adMediumId}'.replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumForm !== undefined) {
        body = params.adMediumForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMediumForm' }, { type: 'parameters' }];
/** Set ad medium active state */ export const setAdMediumActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-broadcast/ad-mediums/{adMediumId}/active/{active}'
        .replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/ad-mediums/{adMediumId}/active/{active}'
        .replaceAll('{adMediumId}', () => encodeURIComponent(String(params.adMediumId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAdMediumActive.paramsOrder = [{ type: 'parameters' }];
/** Returns list of placements */ export const getAllAdPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.placementFilterParams === undefined) {
        throw new Error('Missing required body: placementFilterParams');
    }
    const path = '/api/ws-broadcast/adplacements/filter';
    const pathInternal = '/api/adplacements/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placementFilterParams !== undefined) {
        body = params.placementFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAdPlacements.paramsOrder = [{ type: 'body', paramName: 'placementFilterParams' }];
/** Creates placement */ export const createAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.placement === undefined) {
        throw new Error('Missing required body: placement');
    }
    const path = '/api/ws-broadcast/adplacements';
    const pathInternal = '/api/adplacements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placement !== undefined) {
        body = params.placement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPlacement.paramsOrder = [{ type: 'body', paramName: 'placement' }];
/** Get placement */ export const getAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-broadcast/adplacements/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/adplacements/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPlacement.paramsOrder = [{ type: 'parameters' }];
/** Updates placement */ export const updateAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.placement === undefined) {
        throw new Error('Missing required body: placement');
    }
    const path = '/api/ws-broadcast/adplacements/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/adplacements/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placement !== undefined) {
        body = params.placement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPlacement.paramsOrder = [{ type: 'body', paramName: 'placement' }, { type: 'parameters' }];
/** Set ad placement active state */ export const setAdPlacementActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-broadcast/adplacements/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/adplacements/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAdPlacementActive.paramsOrder = [{ type: 'parameters' }];
/** Returns list of adTypes */ export const getAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adTypeFilterParams === undefined) {
        throw new Error('Missing required body: adTypeFilterParams');
    }
    const path = '/api/ws-broadcast/ad-types/filter';
    const pathInternal = '/api/ad-types/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeFilterParams !== undefined) {
        body = params.adTypeFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdTypes.paramsOrder = [{ type: 'body', paramName: 'adTypeFilterParams' }];
/** Create AdType */ export const createAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adTypeForm === undefined) {
        throw new Error('Missing required body: adTypeForm');
    }
    const path = '/api/ws-broadcast/ad-types';
    const pathInternal = '/api/ad-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeForm !== undefined) {
        body = params.adTypeForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdType.paramsOrder = [{ type: 'body', paramName: 'adTypeForm' }];
/** Get adType */ export const getAdTypeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adTypeId === undefined) {
        throw new Error('Missing required parameter: adTypeId');
    }
    const path = '/api/ws-broadcast/ad-types/{adTypeId}'.replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)));
    const pathInternal = '/api/ad-types/{adTypeId}'.replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdTypeById.paramsOrder = [{ type: 'parameters' }];
/** Update adType */ export const updateAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adTypeId === undefined) {
        throw new Error('Missing required parameter: adTypeId');
    }
    if (params.adTypeForm === undefined) {
        throw new Error('Missing required body: adTypeForm');
    }
    const path = '/api/ws-broadcast/ad-types/{adTypeId}'.replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)));
    const pathInternal = '/api/ad-types/{adTypeId}'.replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeForm !== undefined) {
        body = params.adTypeForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdType.paramsOrder = [{ type: 'body', paramName: 'adTypeForm' }, { type: 'parameters' }];
/** Set ad type active state */ export const setAdTypeActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adTypeId === undefined) {
        throw new Error('Missing required parameter: adTypeId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-broadcast/ad-types/{adTypeId}/active/{active}'
        .replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/ad-types/{adTypeId}/active/{active}'
        .replaceAll('{adTypeId}', () => encodeURIComponent(String(params.adTypeId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAdTypeActive.paramsOrder = [{ type: 'parameters' }];
/** Returns list of all adTypes */ export const getBatchAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-broadcast/ad-types/batch';
    const pathInternal = '/api/ad-types/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdTypes.paramsOrder = [{ type: 'parameters' }];
/** Returns list of adSpecs */ export const getAdSpecs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecFilterParams === undefined) {
        throw new Error('Missing required body: adSpecFilterParams');
    }
    const path = '/api/ws-broadcast/ad-specs/filter';
    const pathInternal = '/api/ad-specs/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecFilterParams !== undefined) {
        body = params.adSpecFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecs.paramsOrder = [{ type: 'body', paramName: 'adSpecFilterParams' }];
/** Creates adSpec */ export const createAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecForm === undefined) {
        throw new Error('Missing required body: adSpecForm');
    }
    const path = '/api/ws-broadcast/ad-specs';
    const pathInternal = '/api/ad-specs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecForm !== undefined) {
        body = params.adSpecForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpecForm' }];
/** Returns adSpec */ export const getAdSpecById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    const pathInternal = '/api/ad-specs/{adSpecId}'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecById.paramsOrder = [{ type: 'parameters' }];
/** Updates adSpec */ export const updateAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    if (params.adSpecForm === undefined) {
        throw new Error('Missing required body: adSpecForm');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    const pathInternal = '/api/ad-specs/{adSpecId}'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecForm !== undefined) {
        body = params.adSpecForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpecForm' }, { type: 'parameters' }];
/** Set ad spec active state */ export const setAdSpecActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}/active/{active}'
        .replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/ad-specs/{adSpecId}/active/{active}'
        .replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAdSpecActive.paramsOrder = [{ type: 'parameters' }];
/** Check for adSpec campaign positions */ export const checkForAdSpecCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}/check-for-positions'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    const pathInternal = '/api/ad-specs/{adSpecId}/check-for-positions'.replaceAll('{adSpecId}', () => encodeURIComponent(String(params.adSpecId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdSpecCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Get ad prices by ids */ export const getAdPricesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceIds === undefined) {
        throw new Error('Missing required body: adPriceIds');
    }
    const path = '/api/ws-broadcast/adprices/by-ids';
    const pathInternal = '/api/adprices/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceIds !== undefined) {
        body = params.adPriceIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPricesByIds.paramsOrder = [{ type: 'body', paramName: 'adPriceIds' }];
/** Returns list of adPrices */ export const getAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceFilterParams === undefined) {
        throw new Error('Missing required body: adPriceFilterParams');
    }
    const path = '/api/ws-broadcast/ad-prices/filter';
    const pathInternal = '/api/ad-prices/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceFilterParams !== undefined) {
        body = params.adPriceFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPrices.paramsOrder = [{ type: 'body', paramName: 'adPriceFilterParams' }];
/** Creates adprice */ export const createAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceForm === undefined) {
        throw new Error('Missing required body: adPriceForm');
    }
    const path = '/api/ws-broadcast/ad-prices';
    const pathInternal = '/api/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceForm !== undefined) {
        body = params.adPriceForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPrice.paramsOrder = [{ type: 'body', paramName: 'adPriceForm' }];
/** Returns adPrice */ export const getAdPriceById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    const pathInternal = '/api/ad-prices/{adPriceId}'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPriceById.paramsOrder = [{ type: 'parameters' }];
/** Updates adPrice */ export const updateAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    if (params.adPriceForm === undefined) {
        throw new Error('Missing required body: adPriceForm');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    const pathInternal = '/api/ad-prices/{adPriceId}'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceForm !== undefined) {
        body = params.adPriceForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPrice.paramsOrder = [{ type: 'body', paramName: 'adPriceForm' }, { type: 'parameters' }];
/** Set ad price active state */ export const setAdPriceActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}/active/{active}'
        .replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/ad-prices/{adPriceId}/active/{active}'
        .replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAdPriceActive.paramsOrder = [{ type: 'parameters' }];
/** Check for adPrice campaign positions */ export const checkForAdPriceCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}/check-for-positions'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    const pathInternal = '/api/ad-prices/{adPriceId}/check-for-positions'.replaceAll('{adPriceId}', () => encodeURIComponent(String(params.adPriceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdPriceCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns list of pricelists */ export const getPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.priceListFilterParams === undefined) {
        throw new Error('Missing required body: priceListFilterParams');
    }
    const path = '/api/ws-broadcast/price-lists/filter';
    const pathInternal = '/api/price-lists/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.priceListFilterParams !== undefined) {
        body = params.priceListFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPriceLists.paramsOrder = [{ type: 'body', paramName: 'priceListFilterParams' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionFilterParams === undefined) {
        throw new Error('Missing required body: campaignPositionFilterParams');
    }
    const path = '/api/ws-broadcast/campaign-positions/filter';
    const pathInternal = '/api/campaign-positions/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionFilterParams !== undefined) {
        body = params.campaignPositionFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionFilterParams' }];
export const createOrUpdateCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    const path = '/api/ws-broadcast/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionForms !== undefined) {
        body = params.campaignPositionForms;
    }
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateCampaignPositions.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionForms' },
    { type: 'parameters' },
];
/** Returns campaign position by id */ export const getCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-broadcast/campaign-positions/{campaignPositionId}'.replaceAll('{campaignPositionId}', () => encodeURIComponent(String(params.campaignPositionId)));
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replaceAll('{campaignPositionId}', () => encodeURIComponent(String(params.campaignPositionId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
export const deleteCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-broadcast/campaign-positions/{campaignPositionId}'.replaceAll('{campaignPositionId}', () => encodeURIComponent(String(params.campaignPositionId)));
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replaceAll('{campaignPositionId}', () => encodeURIComponent(String(params.campaignPositionId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const updateDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.discountForm === undefined) {
        throw new Error('Missing required body: discountForm');
    }
    const path = '/api/ws-broadcast/campaign-positions/update-discounts';
    const pathInternal = '/api/campaign-positions/update-discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.discountForm !== undefined) {
        body = params.discountForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountForm' }, { type: 'parameters' }];
export const getReportingCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    const path = '/api/ws-broadcast/reporting/campaign-positions';
    const pathInternal = '/api/reporting/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns adPrices for reporting */ export const getReportingAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-broadcast/reporting/ad-prices';
    const pathInternal = '/api/reporting/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingAdPrices.paramsOrder = [{ type: 'parameters' }];
/** Extracts campaign positions to new campaign */ export const extractCampaignPositionsToNewCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-broadcast/campaign-positions/extract-new-campaign';
    const pathInternal = '/api/campaign-positions/extract-new-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
extractCampaignPositionsToNewCampaign.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
/** Returns paginated list of ad specs containing matching campaign positions */ export const getBookingAdSpecsWithCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-broadcast/booking/ad-specs-with-campaign-positions';
    const pathInternal = '/api/booking/ad-specs-with-campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBookingAdSpecsWithCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'filter' }];
/** Returns batch campaign positions */ export const getBatchCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/campaign-positions';
    const pathInternal = '/api/batch/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns batch admediums */ export const getBatchAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/admediums';
    const pathInternal = '/api/batch/admediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdMediums.paramsOrder = [{ type: 'parameters' }];
/** Returns ad prices */ export const getBatchAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/ad-prices';
    const pathInternal = '/api/batch/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.period : (params.period ?? queryDefaults?.['period']);
        if (value !== undefined) {
            urlParams.append('period', value.toString());
        }
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdPrices.paramsOrder = [{ type: 'parameters' }];
/** Returns batch placements */ export const getBatchPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/placements';
    const pathInternal = '/api/batch/placements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchPlacements.paramsOrder = [{ type: 'parameters' }];
/** Cloning campaign positions to new campaign */ export const cloneCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.originalCampaignId === undefined) {
        throw new Error('Missing required parameter: originalCampaignId');
    }
    const path = '/api/ws-broadcast/campaign-positions/clone-by-campaign';
    const pathInternal = '/api/campaign-positions/clone-by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    if (params.originalCampaignId !== undefined) {
        urlParams.append('originalCampaignId', params.originalCampaignId.toString());
    }
    {
        const value = queryDefaults === false
            ? params.shouldFetchActualCommission
            : (params.shouldFetchActualCommission ?? queryDefaults?.['shouldFetchActualCommission']);
        if (value !== undefined) {
            urlParams.append('shouldFetchActualCommission', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.manualStartDate : (params.manualStartDate ?? queryDefaults?.['manualStartDate']);
        if (value !== undefined) {
            urlParams.append('manualStartDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.manualEndDate : (params.manualEndDate ?? queryDefaults?.['manualEndDate']);
        if (value !== undefined) {
            urlParams.append('manualEndDate', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Find campaign positions with inactive before cloning */ export const findInactiveProductPositionsOnClone = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-broadcast/campaigns/{campaignId}/campaign-positions/inactive-product'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/inactive-product'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findInactiveProductPositionsOnClone.paramsOrder = [{ type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-broadcast/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
